<h3 class="modal-title">
  <span>{{'selfChangePassword.header' | translate}}</span>
  <button mat-icon-button type="button"
  class="clear-btn"
          (click)="closeModal()"
          [matTooltip]="'common.buttons.close' | translate">
    <mat-icon >close</mat-icon>
  </button>
</h3>
<div class="modal-content">
  <p class="mandatory">* {{'validations.mandatoryFields' | translate}}</p>

  <form #form="ngForm" (ngSubmit)="form.valid && onSubmit()" class="full-width-controls form-self-edit">
    <app-form-error-list formName="selfChangePassword" [errorMessage]="responseErrorCode$ | async"></app-form-error-list>

    <div class="highlight">
      <app-form-group>
        <label for="old-password">{{'selfChangePassword.old-password' | translate}} *</label>
        <input matInput [(ngModel)]="model.Old_Password" type="password" id="old-password" name="old-password" required>
      </app-form-group>
    </div>

    <app-form-group>
      <label for="password-tag">{{'selfChangePassword.password-tag' | translate}} *</label>
      <input matInput [(ngModel)]="model.New_Password" type="password" id="password-tag" name="password-tag" required appPasswordStrengthValidator>
    </app-form-group>

    <app-form-group>
      <label for="password-tag-confirm">{{'selfChangePassword.password-tag-confirm' | translate}} *</label>
      <input matInput [(ngModel)]="passwordConfirm" type="password" id="password-tag-confirm" name="password-tag-confirm" required [appSamePasswordValidator]="model.New_Password">
    </app-form-group>

    <p class="contextual-error py-10">{{'selfChangePassword.passwordWarning' | translate}}</p>

    <div class="buttons-bar">
      <button mat-button class="btn-primary" type="submit">{{'common.buttons.changePassword' | translate | titlecase}}</button>
      <button mat-button class="btn-reset" type="reset" (click)="closeModal()">{{'common.buttons.cancel' | translate | titlecase}}</button>
    </div>
  </form>
</div>
